import axiosHttp from "services/axiosHttp";

// Change Request Service Functions
export const changeRequestService = {
  // Create change request
  createChangeRequest: async (data) => {
    const response = await axiosHttp.post("/pmo/change-request", data);
    return response.data;
  },

  // Get change request list with optional params
  getChangeRequestList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/change-request", { params });
    return response.data;
  },

  // Get single change request by ID
  getChangeRequest: async (id) => {
    const response = await axiosHttp.get(`/pmo/change-request/${id}`);
    return response.data;
  },

  // Update change request
  updateChangeRequest: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/change-request/${id}`, data);
    return response.data;
  },

  // Delete change request
  deleteChangeRequest: async (id) => {
    const response = await axiosHttp.post(`/pmo/change-request-delete/${id}`);
    return response.data;
  },

  // Update change request status
  updateChangeRequestStatus: async (data) => {
    const response = await axiosHttp.put(`/pmo/change-request/${data.id}/status/${data.status}`, data);
    return response.data;
  },

  // Get change requests by project
  getChangeRequestsByProject: async (projectId) => {
    return axiosHttp.get(`/pmo/change-request/project/${projectId}`);
  }
};
